import { render } from "./NeedsToQuoteBanner.vue?vue&type=template&id=7957b4d5&scoped=true"
import script from "./NeedsToQuoteBanner.vue?vue&type=script&lang=js"
export * from "./NeedsToQuoteBanner.vue?vue&type=script&lang=js"

import "./NeedsToQuoteBanner.vue?vue&type=style&index=0&id=7957b4d5&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3554799265/src/syndesi-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7957b4d5"]])

export default __exports__